import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import getIn from 'transmute/getIn';
import I18n from 'I18n';
import { fromMoment, toMoment } from 'foundations-components/transitional/utils/SimpleDate';
import UIFloatingFormControl from 'UIComponents/form/UIFloatingFormControl';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import UIDateInput from 'UIComponents/dates/UIDateInput';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { READ_ONLY } from 'customer-data-objects/property/AccessLevel';
import { updateDealProperty } from '../../actions/StagedDealsUpdatesActions';
import { getStagedDealsUpdates } from '../../selectors/stagedDealsUpdatesSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const DatePicker = ({
  columnName,
  row
}) => {
  const dispatch = useDispatch();
  const stagedDealUpdates = useSelector(getStagedDealsUpdates)[row.id];
  const stagedValue = stagedDealUpdates && stagedDealUpdates[columnName];
  const doesPropertyHaveStagedValue = stagedDealUpdates && columnName in stagedDealUpdates;
  const date = doesPropertyHaveStagedValue ? stagedValue : row.properties[columnName].value;
  const handleChange = useCallback(e => dispatch(updateDealProperty({
    dealId: row.id,
    property: columnName,
    value: toMoment(e.target.value).valueOf()
  })), [columnName, dispatch, row.id]);
  const accessLevel = useAccessLevel({
    objectType: 'DEAL',
    propertyName: columnName
  });
  const canEditObject = Boolean(getIn(['currentUserPermissions', 'canEdit'], row));
  if (accessLevel !== READ_ONLY && canEditObject) {
    const simpleDate = date ? fromMoment(I18n.moment(Number(date))) : null;
    return /*#__PURE__*/_jsx(UIFloatingFormControl, {
      className: "p-all-0",
      hideEditIcon: true,
      children: /*#__PURE__*/_jsx(UIDateInput, {
        className: "p-all-0",
        value: simpleDate,
        onChange: handleChange
      })
    });
  }
  if (date) {
    return /*#__PURE__*/_jsx(FormattedDateTime, {
      value: Number(date),
      format: "ll"
    });
  }
  return null;
};
export default DatePicker;